import { render, staticRenderFns } from "./ReportTaggableList.vue?vue&type=template&id=6a5fdaac&"
import script from "./ReportTaggableList.vue?vue&type=script&lang=js&"
export * from "./ReportTaggableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5fdaac')) {
      api.createRecord('6a5fdaac', component.options)
    } else {
      api.reload('6a5fdaac', component.options)
    }
    module.hot.accept("./ReportTaggableList.vue?vue&type=template&id=6a5fdaac&", function () {
      api.rerender('6a5fdaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportTaggableList/ReportTaggableList.vue"
export default component.exports